module.exports = __webpack_public_path__ + "img/pic_5.54d8ebfd.png";